import React, { FC, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Result,
  Row,
  Spin,
} from "antd";
import { useMutation } from "@apollo/client";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import WhiteVase from "../../assets/images/whiteVase.png";
import {
  ExpertText,
  HeaderSubTitle,
  MediumHeaderTitle,
} from "../../Components/Text3D";
import Logo from "../../assets/images/logo.png";
import MassageIcon from "../../assets/images/massageIcon.png";
import GoogleLogin from "react-google-login";
import { LOGIN_USER } from "../../Apollo/auth/loginMutation";
import FacebookLogin from "react-facebook-login";
import { GOOGLE_LOGIN } from "../../Apollo/auth/googleLoginMutation";
import { setCookies, setUserData, setUserId } from "../../utils/utilsFunctions";
import { FACEBOOK_LOGIN } from "../../Apollo/auth/facebookLoginMutation";
import { BorderButton } from "../../Components/Button3D";
import GoogleIcon from "../../assets/images/google.png";
import { FORGOT_PASSWORD } from "../../Apollo/graphql/Mutation/ForgotPasswordMutation";
// import FacebookIcon from '../../assets/images/facebook.png';

const ImageX = styled.img`
  width: 100%;
  height: 100%;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
interface ButtonProps {
  readonly bg?: boolean;
}
const FormWrapper = styled(Col)`
  display: flex;
  flex-direction: column;
  padding-top: 5rem;

  @media (max-width: 1024px) {
    margin: 0 auto;
    padding-top: 2rem;
  }
`;
const LogoDiv = styled(Row)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 3.5rem;

  @media (max-width: 1024px) {
    margin-bottom: 1rem;
  }
`;
const FormX = styled(Form)`
  margin-top: 3rem;
  .ant-form-item-label > label {
    font-size: 20px;
  }
  @media (max-width: 1024px) {
    margin-top: 0;
  }
  /* 
  @media (max-width: 768px) {
    margin-top: 0;
  } */
`;
const LogoImg = styled.img`
  @media screen and (max-width: 768px) {
  }
`;
const ButtonA = styled(Button)<ButtonProps>`
  background-color: ${(props) => (props.bg ? "#1196DD" : "#09B94F")};
  width: 100%;
  height: 3rem;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  line-height: 20px;
`;
const InputA = styled(Input)`
  border: none;
  outline: none;
  border-bottom: 0.833602px solid #03014c;
  border-radius: 0%;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 24px;
  line-height: 20px;
  box-shadow: none;
  .ant-input-lg {
    font-size: 20px;
  }
`;
const InputP = styled(Input.Password)`
  border: none;
  outline: none;
  border-bottom: 0.833602px solid #03014c;
  border-radius: 0%;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 24px;
  line-height: 20px;
  box-shadow: none;
  .ant-input-lg {
    font-size: 20px;
  }
`;
const StyledFormItem = styled(Form.Item)`
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 20px;
`;

const SufImg = styled.img`
  height: 20px;
  width: 20px;
`;
const FacebookButtonWrapper = styled.div`
  margin-top: 2rem;
  span {
    display: block;
  }
  button {
    width: 100%;
  }
`;

const SignInPage: FC = (props) => {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isForgotModalVisible, setIsForgotModalVisible] = useState(false);
  const [forgotPasswordSuccess, setForgetPasswordSuccess] = useState<any>();

  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loginMutation] = useMutation(LOGIN_USER);
  const [googleLoginMutation] = useMutation(GOOGLE_LOGIN);
  const [facebookLoginMutation] = useMutation(FACEBOOK_LOGIN);
  const [forgotPasswordMutation, { loading: forgotModalLoading }] =
    useMutation(FORGOT_PASSWORD);

  const history = useHistory();
  const location = useLocation();
  const queryString = location.search;
  let SearchParams = new URLSearchParams(queryString);
  let redirectRoute = SearchParams.get("redirect");

  const onFinish = (values: any) => {
    setLoading(true);
    loginMutation({
      variables: {
        email: values.email,
        password: values.password,
      },
    })
      .then((data) => {
        setLoading(false);
        setUserId(data.data.loginNew.user._id);
        setCookies(data.data.loginNew.jwt);
        setUserData(JSON.stringify(data.data.loginNew.user));

        const user = data.data.loginNew.user;
        const authUser = user && user.role === "admin";

        !!authUser
          ? history.push(!redirectRoute ? "/admin" : `${redirectRoute}`)
          : history.push(
              !redirectRoute ? "/dashboard/orders" : `${redirectRoute}`
            );
      })
      .catch((e) => {
        setErrorMessage(e?.graphQLErrors[0]?.message);
        if (
          e?.graphQLErrors[0]?.message === "Your account is not activated yet!"
        ) {
          setErrorMessage(
            `${e?.graphQLErrors[0]?.message} Please check email and click the given url to activate your account.`
          );
          setIsModalVisible(true);
        } else {
          if (e?.graphQLErrors[0]?.message) {
            notification.error({
              message: "Error",
              description: e.graphQLErrors[0].message,
            });
          }
        }
        setLoading(false);
        // setLoadingButton(false);
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const responseGoogle = (response: any) => {
    setLoading(true);
    googleLoginMutation({
      variables: {
        tokenId: response.tokenId,
      },
    })
      .then((data) => {
        setLoading(false);
        setLoadingButton(false);
        setUserId(data.data.googleLogin.user._id);
        setCookies(data.data.googleLogin.jwt);
        setUserData(JSON.stringify(data.data.googleLogin.user));

        const user = data.data.googleLogin.user;
        const authUser = user && user.role === "admin";

        !!authUser
          ? history.push(!redirectRoute ? "/admin" : `${redirectRoute}`)
          : history.push(
              !redirectRoute ? "/dashboard/orders" : `${redirectRoute}`
            );
      })
      .catch((e) => {
        console.log('---e-----', e)
        setLoading(false);
        setLoadingButton(false);
        alert("Error on Google Login");
      });
  };
  const responseFacebook = (response: any) => {
    setLoading(true);
    if (response && response.status === "unknown") {
      setLoading(false);
      return;
    }
    facebookLoginMutation({
      variables: {
        userID: response.userID,
        accessToken: response.accessToken,
      },
    })
      .then((data) => {
        setLoading(false);
        setUserId(data.data.facebookLogin.user._id);
        setCookies(data.data.facebookLogin.jwt);
        setUserData(JSON.stringify(data.data.facebookLogin.user));

        const user = data.data.facebookLogin.user;
        const authUser = user && user.role === "admin";

        !!authUser
          ? history.push(!redirectRoute ? "/admin" : `${redirectRoute}`)
          : history.push(
              !redirectRoute ? "/dashboard/orders" : `${redirectRoute}`
            );
      })
      .catch((e) => {
        setLoading(false);
        alert("Error on Facebook Login");
      });
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // forgot modal
  const handleForgotModalOpen = () => {
    setIsForgotModalVisible(true);
  };
  const handleForgotModalOk = () => {
    setIsForgotModalVisible(false);
  };
  const handleForgotModalCancel = () => {
    setIsForgotModalVisible(false);
  };
  const handleForgotFinish = async (values) => {
    try {
      const response = await forgotPasswordMutation({
        variables: {
          email: values.email,
        },
      });
      setForgetPasswordSuccess(response.data.forgotPassword);
    } catch (e: any) {
      console.log(e?.graphQLErrors[0].message);
    }
  };
  const handleForgotFinishFailed = () => {};
  return (
    <Spin spinning={loading}>
      <div style={{ height: "100vh" }}>
        <Row>
          <Col lg={{ span: 11 }} md={{ span: 11 }} xs={{ span: 24 }}>
            <ImageX src={WhiteVase} alt="" />
          </Col>
          <Col lg={{ span: 13 }} md={{ span: 13 }} xs={{ span: 24 }}>
            <Modal
              bodyStyle={{ padding: "40px 40px 0" }}
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              cancelButtonProps={{ style: { display: "none" } }}
            >
              <p>{errorMessage}</p>
            </Modal>
            <Modal
              title="Forgot Password?"
              visible={isForgotModalVisible}
              onOk={handleForgotModalOk}
              onCancel={handleForgotModalCancel}
              width={400}
              cancelButtonProps={{ style: { display: "none" } }}
              okType="link"
              okText="Back to Login"
            >
              {forgotModalLoading && (
                <Spin style={{ display: "flex", justifyContent: "center" }} />
              )}
              {!forgotPasswordSuccess ? (
                <div>
                  <p>
                    Please enter your email address and we'll send you a link to
                    reset your password.
                  </p>
                  <Form
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={handleForgotFinish}
                    onFinishFailed={handleForgotFinishFailed}
                    autoComplete="off"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "auto",
                    }}
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your username!",
                        },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ width: "100%" }}
                      >
                        Reset Password
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              ) : (
                <Result title="Please check your email to reset your password" />
              )}
            </Modal>
            <FormWrapper
              lg={{ offset: 2, span: 17 }}
              md={{ offset: 1, span: 18 }}
              xs={{ offset: 2, span: 22 }}
            >
              <LogoDiv>
                <Col lg={{ span: 12 }} md={{ span: 12 }}>
                  <NavLink to="/">
                    <LogoImg src={Logo} alt="" />
                  </NavLink>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }}>
                  <ExpertText dark style={{ marginTop: ".7rem" }}>
                    Do you have an account ?{" "}
                    <NavLink to="/register">Sign Up</NavLink>{" "}
                  </ExpertText>
                </Col>
              </LogoDiv>
              <MediumHeaderTitle dark>Login to Your Account!</MediumHeaderTitle>
              <FormX
                // name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <StyledFormItem
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your Email!" },
                  ]}
                >
                  <InputA
                    size="large"
                    suffix={<SufImg src={MassageIcon} alt="" />}
                    placeholder="Enter your email"
                  />
                </StyledFormItem>

                <StyledFormItem
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <InputP
                    placeholder="Please Enter your Password"
                    size="large"
                  />
                </StyledFormItem>
                <div
                  style={{
                    display: "flex",
                    flexFlow: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>Remember me</Checkbox>
                    <Button type="link" onClick={handleForgotModalOpen}>
                      Forgot your Password?
                    </Button>
                  </Form.Item>
                </div>

                <Form.Item>
                  <ButtonA
                    bg
                    onClick={() => setLoading(true)}
                    type="primary"
                    htmlType="submit"
                    style={{ marginTop: "1.5rem" }}
                    loading={loadingButton}
                  >
                    Login to Continue
                  </ButtonA>
                </Form.Item>
              </FormX>
              <HeaderSubTitle dark style={{ textAlign: "center" }}>
                Or
              </HeaderSubTitle>
              <GoogleLogin
                clientId="777301032809-92p7mn98l7rq1qqia0s41qdocctdus3n.apps.googleusercontent.com"
                render={(renderProps) => (
                  <BorderButton
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                  >
                    <img
                      src={GoogleIcon}
                      alt=""
                      style={{ marginRight: "1rem" }}
                    />
                    Login with Google
                  </BorderButton>
                )}
                buttonText="Login with Google"
                onSuccess={responseGoogle}
                onFailure={(err) => {
                  setLoading(false);
                }}
                cookiePolicy={"single_host_origin"}
                onRequest={() => {
                  setLoading(true);
                }}
              />
              <FacebookButtonWrapper>
                <FacebookLogin
                  appId="940284243207634"
                  autoLoad={false}
                  fields="name,email"
                  callback={responseFacebook}
                />
              </FacebookButtonWrapper>
            </FormWrapper>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default SignInPage;
